import React from "react";
import "./work.css";
import { projectsData } from "./Data";
import WorkItems from "./WorkItems";

const Work = () => {
  return (
    <section
      className="w-screen py-12 px-6 md:pt-24 md:pb-12 md:px-16"
      id="portfolio"
    >
      <h2 className="text-2xl md:text-4xl text-left md:text-center mb-8 md:mb-12">
        Recent Works
      </h2>
      <div className="max-w-5xl mx-auto space-y-6">
        <div
          className="grid grid-cols-1 sm:grid-cols-3 gap-8"
          // data-aos="zoom-in-down"
          // data-aos-duration="50"
        >
          {projectsData.map((item) => {
            return <WorkItems item={item} key={item.id} />;
          })}
        </div>
      </div>
    </section>
  );
};

export default Work;
